import React, { Component } from "react";
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './assets/components/Homepage';
import Telecomunicaciones from './assets/components/Telcopage';
import TI from './assets/components/TIpage';
import IoT from './assets/components/IoTpage';
import Ciberseguridad from './assets/components/Ciberpage';
import CiberCra from './assets/components/CiberCrapage';
import CiberSoc from './assets/components/CiberSocpage';
import CiberCti from './assets/components/CiberCtipage';
import CiberCsirt from './assets/components/CiberCsirtpage';
import CiberIsg from './assets/components/CiberIsgpage';
import Electricidad from './assets/components/Elecpage';
import About from './assets/components/Aboutpage';
import Contact from './assets/components/Contactpage';
import Error from './assets/components/Errorpage';
import UseCases from "./assets/components/Usecasespage";
import WorkWithUs from "./assets/components/Workwithuspage";
import ScrollToTop from "./assets/components/ScrollToTop";
import MainLayout from "./assets/components/MainLayout";
import CiberseguridadLayout from './assets/components/CiberseguridadLayout';


class Router extends Component {

    render() {
        return (
            <BrowserRouter>
  <ScrollToTop>
    <Routes>

      {/* Layout principal */}
      <Route element={<MainLayout />}>

        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/Servicios-Telecomunicaciones" element={<Telecomunicaciones />} />
        <Route path="/Servicios-TI" element={<TI />} />
        <Route path="/Servicios-IoT" element={<IoT />} />

        {/* Layout de Ciberseguridad */}
        <Route
          path="/Servicios-Ciberseguridad"
          element={<CiberseguridadLayout />}
        >
          <Route index element={<Ciberseguridad />} />
          <Route path="prevencion-cra" element={<CiberCra />} />
          <Route path="deteccion-soc" element={<CiberSoc />} />
          <Route path="inteligencia-cti" element={<CiberCti />} />
          <Route path="respuesta-csirt" element={<CiberCsirt />} />
          <Route path="cumplimiento-isg" element={<CiberIsg />} />
        </Route>

        <Route path="/Servicios-Electricidad" element={<Electricidad />} />
        <Route path="/About" element={<About />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/Use-cases" element={<UseCases />} />
        <Route path="/Work-with-Us" element={<WorkWithUs />} />

        <Route path="*" element={<Error />} />

      </Route>
    </Routes>
  </ScrollToTop>
</BrowserRouter>

        );
    }
}

export default Router;